import { Navigate } from "react-router";
import { screens } from "../../screens/Navigation.types";
import { useUser } from "../../store/auth/AuthSelectors";
import { ReverseAuthGuardProps } from "./Guard.types";

export function ReverseAuthGuard({ children }: ReverseAuthGuardProps) {
  const user = useUser();
  return user ? <Navigate replace to={screens.root} /> : <>{children}</>;
}
